module.exports = __webpack_public_path__ + "static/img/2.320788f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.png
// module id = chPc
// module chunks = 2